import {makeAutoObservable} from 'mobx';

import {Unreads} from '@/domain/models/Unreads';

class UnreadStore {
  matches: number = -1;
  matches_favourites: number = -1;
  reactions: number = -1;
  visits: number = -1;

  constructor() {
    makeAutoObservable(this);
  }

  setUndead(unread: Unreads) {
    Object.assign(this, unread);
  }

  addNewUnreadMatch() {
    this.matches += 1;
  }

  readMatch() {
    this.matches -= 1;
  }

  readMatchFavourites() {
    this.matches_favourites = 0;
  }
}

export const unreadStore = new UnreadStore();
